export enum CLAIM_FABRICATOR_STATUS {
  NEW = 'New',
  SENDING = 'Sending',
  SENT = 'Sent',
  ADDITIONAL_INFORMATION_REQUESTED = 'FabricatorAdditionalInformationRequested',
  AWAITING_DECISION = 'FabricatorAwaitingDecision',
  PRE_APPROVED = 'FabricatorPreApproved',
  ACCEPTED = 'FabricatorAccepted',
  DECLINED = 'FabricatorDeclined',
  DISPATCHED_TO_GLAZIER = 'FabricatorDispatchedToGlazier',
  PARTIALLY_COMPLETED = 'FabricatorPartiallyCompleted',
  PARTIALLY_COMPLETED_INVOICE_ADDED = 'FabricatorPartiallyCompletedInvoiceAdded',
  COMPLETED = 'FabricatorCompleted',
  INVOICED = 'FabricatorInvoiced',
}

export enum CLAIM_FMI_STATUS {
  REGISTERED = 'Registered',
  SENDING_TO_CUSTOMER = 'SendingToCustomer',
  SENT_TO_CUSTOMER = 'SentToCustomer',
  ADDITIONAL_INFORMATION_REQUESTED = 'AdditionalInformationRequested',
  AWAITING_DECISION = 'AwaitingDecision',
  TECHNICAL_REVIEW_REQUESTED = 'TechnicalReviewRequested',
  PRE_APPROVED = 'PreApproved',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
  DISPATCHED_TO_GLAZIER = 'DispatchedToGlazier',
  GLAZIER_REASSIGNED = 'GlazierReassigned',
  PARTIALLY_COMPLETED = 'PartiallyCompleted',
  PARTIALLY_COMPLETED_INVOICE_ADDED = 'PartiallyCompletedInvoiceAdded',
  COMPLETED = 'Completed',
  INVOICED = 'Invoiced',
}

export const CLAIM_FMI_STATUS_OPTIONS = [
  { name: 'All Statuses', id: 'ALL_STATUSES' },
  { name: 'Registered', id: CLAIM_FMI_STATUS.REGISTERED },
  { name: 'Sending to Customer', id: CLAIM_FMI_STATUS.SENDING_TO_CUSTOMER },
  { name: 'Sent to Customer', id: CLAIM_FMI_STATUS.SENT_TO_CUSTOMER },
  {
    name: 'Info Requested',
    id: CLAIM_FMI_STATUS.ADDITIONAL_INFORMATION_REQUESTED,
  },
  {
    name: 'Awaiting Decision',
    id: CLAIM_FMI_STATUS.AWAITING_DECISION,
  },
  {
    name: 'Technical Review',
    id: CLAIM_FMI_STATUS.TECHNICAL_REVIEW_REQUESTED,
  },
  { name: 'Pre-Approved', id: CLAIM_FMI_STATUS.PRE_APPROVED },
  { name: 'Accepted', id: CLAIM_FMI_STATUS.ACCEPTED },
  { name: 'Declined', id: CLAIM_FMI_STATUS.DECLINED },
  {
    name: 'Dispatched to Glazier',
    id: CLAIM_FMI_STATUS.DISPATCHED_TO_GLAZIER,
  },
  { name: 'Partially Completed', id: CLAIM_FMI_STATUS.PARTIALLY_COMPLETED },
  { name: 'Completed', id: CLAIM_FMI_STATUS.COMPLETED },
  { name: 'Invoiced', id: CLAIM_FMI_STATUS.INVOICED },
];

export enum CLAIM_CUSTOMER_STATUS {
  NEW_CLAIM = 'NewClaim',
  ADDITIONAL_INFORMATION_REQUIRED = 'AdditionalInformationRequired',
  IN_REVIEW = 'InReview',
  PRE_APPROVED = 'PreApproved',
  ACCEPTED = 'Accepted',
  DECLINED = 'Declined',
  IN_PRODUCTION = 'InProduction',
  WITH_GLAZIER = 'WithGlazier',
  COMPLETED = 'Completed',
}

export enum GLAZED {
  SITE = 'SiteGlazed',
  FACTORY = 'FactoryGlazed',
}

export const GLAZED_LABELS: Record<GLAZED, string> = {
  [GLAZED.SITE]: 'Site glazed',
  [GLAZED.FACTORY]: 'Factory glazed',
};

export const GLAZED_OPTIONS = [
  { name: GLAZED_LABELS[GLAZED.SITE], id: GLAZED.SITE },
  { name: GLAZED_LABELS[GLAZED.FACTORY], id: GLAZED.FACTORY },
];

export enum ISLAND {
  NORTH_ISLAND = 'NorthIsland',
  SOUTH_ISLAND = 'SouthIsland',
}

export const ISLAND_OPTIONS = [
  { name: 'All New Zealand', id: 'ALL_NEW_ZEALAND' },
  { name: 'North Island', id: ISLAND.NORTH_ISLAND },
  { name: 'South Island', id: ISLAND.SOUTH_ISLAND },
];

// FMICE-793: backend `exportType` values (case-insensitive; `Full` is the backend default)
export enum CLAIM_EXPORT_TYPE {
  SPREADSHEET_ONLY = 'SpreadsheetOnly',
  FULL = 'Full',
}

export const CLAIM_EXPORT_OPTIONS = [
  { label: 'Spreadsheet only', value: CLAIM_EXPORT_TYPE.SPREADSHEET_ONLY },
  {
    label: 'Spreadsheet + supporting materials',
    value: CLAIM_EXPORT_TYPE.FULL,
  },
];
